import { useEffect, useState } from 'react';

/**
 * True once `busy` has stayed true for `delayMs`, and false the moment it
 * stops. For a loading indicator that should not flash on a fast answer:
 * InstantSearch's `stalledSearchDelay`, whose default is the 200 ms used here.
 * A request that answers sooner never shows a spinner at all.
 *
 * Not `busy && useDebounce(busy)`: that remembers the last settled `true`, so
 * a second request started within the delay would show the spinner at once.
 * Each busy spell here waits its own full delay.
 */
export function useStalled(busy: boolean, delayMs = 200): boolean {
  const [stalled, setStalled] = useState(false);
  useEffect(() => {
    if (!busy) {
      setStalled(false);
      return;
    }
    const timer = setTimeout(() => setStalled(true), delayMs);
    return () => clearTimeout(timer);
  }, [busy, delayMs]);
  return busy && stalled;
}
